<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-body">
              <b-row v-if="hasOwnerRoles">
                <b-col>
                  <b-form-group>
                    <label for="userdata_input">{{ $t('routes.UserDataShow') }}</label>
                    <model-select
                      id="userdata_input"
                      :options="userDataOptions"
                      v-model="currentUser"></model-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="serviceman">
                <b-col>
                  <p v-if="serviceman.name && serviceman.surname" class="m-0">
                    <b>{{ serviceman.name }} {{ serviceman.surname }}</b>
                  </p>
                  <p v-if="serviceman.mobilePhone" class="m-0"><phoneNumberLink :phoneNumber="serviceman.mobilePhone"/></p>
                  <p v-if="serviceman.userEmail" class="m-0"><a :href="'mailto: ' + serviceman.userEmail">{{ serviceman.userEmail }}</a></p>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col>
                  <DailyPlanServicemanCalendar :key="currentUser"></DailyPlanServicemanCalendar>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import DailyPlanServicemanCalendar from './components/DailyPlanServicemanCalendar/DailyPlanServicemanCalendar'
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import { getUserRoles } from '@/utils/checkRoles'
import moment from 'moment'
import { ModelSelect } from 'vue-search-select'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'
import VueCookie from 'vue-cookie'
export default {
  name: 'Overview',
  components: {
    PhoneNumberLink,
    DailyPlanServicemanCalendar,
    ModelSelect
  },
  data () {
    return {
      serviceman: {},
      userDataOptions: [],
      currentUser: this.getIdLink(this.$route.params.idServiceman)
    }
  },
  created () {
    this.getServicemanData()
    this.getUserData()
  },

  computed: {
    hasOwnerRoles () {
      const roles = getUserRoles().roles
      return roles.includes('ROLE_OWNER') || roles.includes('ROLE_SUPER_USER') || roles.includes('ROLE_CONTROLLING')
    }
  },
  watch: {
    currentUser (val) {
      if (val) {
        this.$router.push({ name: 'DailyPlanOverview', params: { idServiceman: val, date: moment().format('YYYY-MM') } })
        this.getServicemanData()
      }
    }
  },
  methods: {
    async getUserData () {
      if (!this.hasOwnerRoles) {
        return
      }
      let params = {
        idClientType: [3, 4, 5, 8, 14, 15, 16],
        state: 1,
        pagination: false
      }
      const response = await new ApiService('user_datas/list', params).getResults()
      response.items.forEach(entry => {
        this.userDataOptions.push({ value: getId(entry['@id']), text: entry.fullName })
      })
    },
    async getServicemanData () {
      let userDataIri = this.currentUser
      let id = this.getIdLink(this.currentUser)
      if (userDataIri) {
        this.serviceman = await new ApiService('user_datas/' + id).getResults()
      }
    },
    getIdLink (link) {
      if (link === '/api/user_datas/null') {
        link = VueCookie.get('user_data_id')
      }
      return getId(link)
    }
  }
}
</script>
